
export const totalConsumptionColumns = [ 
    {label: "Συμβατικό Σύστημα Pillars kWh", key: "oldRTU"},
    {label: "Νέο Σύστημα Pillars kWh", key: "newRTU"},
    {label: "Συμβατικό Σύστημα LoRaWan NEMA kWh", key: "oldNema"},
    {label: "Νεό Σύστημα LoRaWan NEMA kWh", key: "newNema"},
]

export const gatewayInfoColumns = [
    {label: "Gateway", key: "gateway"},
    {label: "Κατάσταση", key: "state"},
]

export const latestPayloadsColumns = [
    {label: "Συσκευή", key: "device"},
    {label: "Κατάσταση", key: "state"},
    {label: "Πόρτα", key: "port"},
    {label: "Ημ/νία", key: "date"},
]